<template>
<div class="divNavBar">
    <div v-if="prev" @click="prevStep" id="prevStep">
        <!-- <span class="button bigScreen">&#60; Étape précédente</span> -->
        <span class="button bigScreen">{{ finalPrevValue }}</span>
        <img class="arrow littleScreen" :src="'https://preprod.api.defipix.fr/logos/prev_200.png'" alt="previous step" />
        <!-- <i class="em em-point_left finger littleScreen" aria-role="presentation" aria-label="WHITE LEFT POINTING BACKHAND INDEX"></i> -->
    </div>
    <div v-if="next" @click="nextStep" id="nextStep">
        <!-- <span class="button bigScreen">Étape suivante &#62;</span> -->
        <span class="button bigScreen">{{ finalNextValue }}</span>
        <img class="arrow littleScreen" :src="'https://preprod.api.defipix.fr/logos/next_200.png'" alt="next step" />
        <!-- <i class="em em-point_right finger littleScreen" aria-role="presentation" aria-label="WHITE RIGHT POINTING BACKHAND INDEX"></i> -->
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            finalPrevValue: null,
            finalNextValue: null,
            finalPrevFinger: null,
            finalNextFinger: null,
        }
    },
    props: {
        prev: Boolean,
        next: Boolean,
        prevValue: String,
        nextValue: String,
        hideFingerPrev: Boolean,
        hideFingerNext: Boolean,
        disablePrev: Boolean,
        disableNext: Boolean,
    },
    mounted: function() {
        this.finalPrevValue = this.prevValue ? this.prevValue : "Étape précédente";
        this.finalNextValue = this.nextValue ? this.nextValue : "Étape suivante";
        this.finalPrevFinger = this.hideFingerPrev ? !this.hideFingerPrev : true;
        this.finalNextFinger = this.hideFingerNext ? !this.hideFingerNext : true;
    },
    methods: {
        nextStep() {
            this.$parent.nextStep();
            if (this.disableNext) return;
            this.$store.commit('RCetapeNext');
        },
        prevStep() {
            if (this.$parent.$options.parent.etape == 6) {
                this.$parent.prevStep();
            }
            if (this.disablePrev) return;
            this.$store.commit('RCetapePrev');
        }
    }
}
</script>

<style scoped>
.divNavBar {
    margin: 1em;
    padding-bottom: 4em;
}

#prevStep {
    float: left;
    margin: auto;
}

#nextStep {
    float: right;
    margin: auto;
}

.finger {
    height: 2.5em;
    width: 2.5em;
    background-size: 2em;
}

#prevStep:hover, #nextStep:hover {
    cursor: pointer;
    transform: scale(1.025);
}

.littleScreen {
    display: none;
}

.arrow {
    width: 2.5em;
}

@media only screen and (max-width: 520px) {
    .bigScreen {
        display: none;
    }
    .littleScreen {
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderBooth/NavBar.vue